import ScreenDonSection from "./components/screen-don-section";
import {useEffect} from "react";
import {DEBUG} from "../../../../config";


export default function YoudTetKislev2({context,loading, campagneData})
{

    const screenOptions=campagneData?.screenOptions || {}
    const org=context.org

    useEffect(() => {
        document.body.style.overflow="hidden";
        document.body.style.cursor="none";
        document.body.style.userSelect="none";
    }, []);


    if(loading)
    {
        return null
    }

    return (
        <div style={{backgroundColor:"transparent",backgroundImage:DEBUG?"url('/campagne/screen/youdtetkislev/SCREEN-19KISLEV-5786.jpg')":"none",backgroundSize:"cover",backgroundRepeat:"no-repeat",aspectRatio: "16/9", position: "relative"}}>
            <div style={{position:"absolute",bottom:0,width:"100vw"}}>
                <ScreenDonSection context={context} campagneData={campagneData}/>
            </div>
        </div>
    )
}
